import React from "react";
import { Spacer } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import MatchLabelView from "@components/molecules/MatchLabelView";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useState } from "react";
import styled, { useTheme } from "styled-components/native";
import RenderLocationView from "../RenderLocationView/RenderLocationView";
import RenderSocialMediaView from "../RenderSocialMediaView/RenderSocialMediaView";
import ShowMoreItemDetail from "./ShowMoreItemDetail";
import { ProductDetailItemProps } from "./types";
import { DefaultTheme } from "styled-components/native";

const ProductDetailItem = ({
  item,
  itemDetail,
  localSelectedLocation,
  otherDetailsArray,
  otherDetail,
  setLocalSelectedLocation,
  setOtherSelectedLocation,
  currentIndex = 0,
  index = 0,
  otherSelectedLocation,
  setShowPhoneNumber,
  //setMoreNumber,
  productColor,
  isFromMatchPair,
}: ProductDetailItemProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const [addDivider] = useState(item?.clickToShow);

  const updateSelection = (isPrimary: boolean, selectedLocation: any) => {
    if (isPrimary) {
      setLocalSelectedLocation?.(selectedLocation);
    } else {
      setOtherSelectedLocation?.(selectedLocation);
    }
  };

  return (
    <>
      {item?.showNumber === undefined || item?.showNumber === true ? (
        <CustomView>
          {item?.isLocation === true ? (
            <ContainerView>
              <FlexMainView>
                <MainContainerView testID="findMatch.detailItem.location.primary">
                  <RenderLocationView
                    location={item?.description}
                    itemDetail={itemDetail}
                    updateSelection={updateSelection}
                    isPrimary={true}
                    localLocation={
                      localSelectedLocation ? localSelectedLocation : ""
                    }
                  />
                </MainContainerView>
                <Spacer size={SpaceType.Basic} />
                <MainContainerView testID="findMatch.detailItem.location.secondary">
                  <RenderLocationView
                    location={otherDetailsArray[index]?.description}
                    itemDetail={otherDetail?.[currentIndex]}
                    updateSelection={updateSelection}
                    isPrimary={false}
                    localLocation={
                      otherSelectedLocation ? otherSelectedLocation : ""
                    }
                  />
                </MainContainerView>
              </FlexMainView>
            </ContainerView>
          ) : item?.clickToShow === true ? (
            <>
              <ShowMoreItemDetail
                setShowPhoneNumber={setShowPhoneNumber}
                item={item}
                productColor={productColor}
              />
            </>
          ) : item?.name === "socialmedia" ? (
            localSelectedLocation?.contact_whatsapp ||
            localSelectedLocation?.contact_iphone ||
            otherSelectedLocation?.contact_whatsapp ||
            otherSelectedLocation?.contact_iphone ? (
              <FlexMainView>
                <MainContainerView testID="findMatch.detailItem.socialMedia.primary">
                  <RenderSocialMediaView
                    contact_whatsapp={localSelectedLocation?.contact_whatsapp}
                    contact_iphone={localSelectedLocation?.contact_iphone}
                    contact_whatsapp_country_code={
                      localSelectedLocation?.contact_whatsapp_country_code
                    }
                    contact_iphone_country_code={
                      localSelectedLocation?.contact_iphone_country_code
                    }
                    hideSpacer
                  />
                </MainContainerView>
                <Spacer size={SpaceType.Big} />
                <MainContainerView testID="findMatch.detailItem.socialMedia.secondary">
                  <RenderSocialMediaView
                    contact_whatsapp={otherSelectedLocation?.contact_whatsapp}
                    contact_iphone={otherSelectedLocation?.contact_iphone}
                    contact_whatsapp_country_code={
                      otherSelectedLocation?.contact_whatsapp_country_code
                    }
                    contact_iphone_country_code={
                      otherSelectedLocation?.contact_iphone_country_code
                    }
                    hideSpacer
                  />
                </MainContainerView>
              </FlexMainView>
            ) : (
              <></>
            )
          ) : (
            <MatchLabelView
              leftKey={item.title}
              leftValue={item.description}
              addSpacer={true}
              hideDivider={item.hideDivider}
              rightValue={otherDetailsArray[index].description}
              itemContent="start"
              leftDirection={"column"}
              clickable={item?.clickable}
              rightKey={item.title}
              showPadding={true}
              rightPrefixTextTheme={
                item?.color
                  ? (theme[item?.color as keyof DefaultTheme] as string)
                  : theme["core-05"]
              }
              leftPostfixText=""
              itemLeftTextTheme={
                item.isTitle && item.isTitle === true
                  ? theme["core-05"]
                  : theme["core-06"]
              }
              isFixedKeyWidth={true}
              dividerPadding={item.isTitle && item.isTitle === true ? 8 : 4}
              keyTypographyStyle={
                item.isTitle && item.isTitle === true
                  ? typography["H1-B"]
                  : typography["Body-R"]
              }
              keyWidthPercent={30}
              availabilityIcon={item?.name === "available" ? item.icon : ""}
              addDivider={addDivider}
              isFromMatchPair={isFromMatchPair}
            />
          )}
        </CustomView>
      ) : null}
    </>
  );
};

const CustomView = styled.View`
  justify-content: start;
  align-items: start;
  margin-vertical: 6px;
  width: 100%;
  flex: 1;
  flex-basis: auto;
`;

const ContainerView = styled.View<any>`
  flex-direction: row;
  width: 100%;
`;

const FlexMainView = styled.View<any>`
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  flex-basis: auto;
  width: 100%;
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  flex-basis: auto;
  max-width: 47%;
`;

export default ProductDetailItem;
